import { Outlet, createFileRoute } from "@tanstack/react-router";

import { Logo } from "@/components/ui/logo";

export const Route = createFileRoute("/_app/_auth/onboarding/_layout")({
  component: OnboardingLayout,
});

export default function OnboardingLayout() {
  return (
    <div className="relative flex h-screen w-full bg-card">
      <div className="z-10 h-screen w-screen overflow-y-auto px-4 py-12">
        <div className="items-center flex justify-center">
          <Logo />
        </div>
        <Outlet />
      </div>
      <div className="base-grid fixed h-screen w-screen opacity-40" />
      <div className="fixed bottom-0 h-screen w-screen bg-gradient-to-t from-[hsl(var(--card))] to-transparent" />
    </div>
  );
}
